module.exports = __webpack_public_path__ + "media/images/haawk-64efe71d7f38af2f7b258f0eecf9fd47.png";